import * as React from 'react';

import { useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { User } from 'types/embedded/user';
import { formatInputInTz } from 'utils/date';

type Props = {
  createdAt: string;
};

export const BankOperationsListCommentUser: React.FC<Props> = ({ createdAt }) => {
  const record = useRecordContext<Partial<User>>();

  if (!record) {
    return <></>;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Typography fontSize={14} fontWeight={500}>
        {record?.firstName} {record?.lastName}
      </Typography>
      <Typography color="secondary.main" fontSize={14}>
        ·
      </Typography>
      <Typography color="secondary.main" fontSize={14}>
        {formatInputInTz(createdAt, { format: 'dd.MM.yyyy, HH:mm:ss' })}
      </Typography>
    </Box>
  );
};
